import { render, staticRenderFns } from "./Traffic.vue?vue&type=template&id=497f1bd3&scoped=true&"
import script from "./Traffic.vue?vue&type=script&lang=js&"
export * from "./Traffic.vue?vue&type=script&lang=js&"
import style0 from "./Traffic.vue?vue&type=style&index=0&id=497f1bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f1bd3",
  null
  
)

export default component.exports